import { useContext } from "react";
import { PinContext } from "../../contexts/PinContext";

// Shared pin state/toggle for an item of a given type, backed by PinContext +
// localStorage (key `pinned-<type>`). Used by PinButton and by row-action menus.

const listForType = (ctx, type) => {
  switch (type) {
    case "sources":
      return ctx.pinnedSources;
    case "policies":
      return ctx.pinnedPolicies;
    case "dynamicviews":
      return ctx.pinnedDynamicViews;
    case "transfers":
      return ctx.pinnedTransfers;
    case "workspaces":
      return ctx.pinnedWorkspaces;
    default:
      return [];
  }
};

export default function usePin(type, item) {
  const ctx = useContext(PinContext);
  const source = listForType(ctx, type) ?? [];
  const isPinned = source.includes(item);

  const toggle = () => {
    const next = isPinned
      ? source.filter((d) => d !== item)
      : [...source, item];
    ctx.update(type, next);
    localStorage.setItem(`pinned-${type}`, JSON.stringify(next));
  };

  return { isPinned, toggle };
}
